var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUmbrella(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,13A12.08,12.08,0,0,0,13.36,3.41V2.66A1.38,1.38,0,0,0,12,1.32a1.34,1.34,0,0,0-1.33,1.34v.75A12.12,12.12,0,0,0,0,13c-.08.42.33.92.79.5C3,11.25,5.27,11.33,7.39,15.09a.47.47,0,0,0,.84,0C9.06,13.58,10.1,12,12,12c2.42,0,3.67,2.88,3.75,3.09a.47.47,0,0,0,.84,0c2.12-3.76,4.46-3.84,6.63-1.55C23.66,14,24.07,13.46,24,13Zm-13.3.88v5.42A.7.7,0,0,1,10,20a.74.74,0,0,1-.67-.42,1.29,1.29,0,0,0-1.67-.83,1.33,1.33,0,0,0-.83,1.71,3.36,3.36,0,0,0,6.51-1.13V13.92A2.14,2.14,0,0,0,12,13.33,2,2,0,0,0,10.69,13.92Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.258689e8.svg";
export { ForwardRef as ReactComponent };